import { PageScaffold } from "../../shared/ui/PageScaffold";

const publicLinks = [
  { to: "/t/:tenantSlug/schedule", label: "公開スケジュール" },
  { to: "/t/:tenantSlug/events", label: "公開イベント" },
  { to: "/t/:tenantSlug/entry", label: "利用開始" }
];

export function PublicTopPage() {
  return (
    <PageScaffold
      title="MADAMUH LESSON"
      description="公開トップのプレースホルダーです。将来はクラブ情報、公開導線、ログイン導線を表示します。"
      links={publicLinks}
    >
      <p>ここは tenant 公開トップです。</p>
    </PageScaffold>
  );
}

export function PublicSchedulePage() {
  return (
    <PageScaffold
      title="公開スケジュール"
      description="ここに公開月間スケジュールを表示します。"
      links={publicLinks}
    >
      <p>初期版では API 接続前の空画面です。</p>
    </PageScaffold>
  );
}

export function PublicEventsPage() {
  return (
    <PageScaffold
      title="公開イベント"
      description="ここに公開イベント一覧を表示します。"
      links={publicLinks}
    >
      <p>初期版では API 接続前の空画面です。</p>
    </PageScaffold>
  );
}

export { PublicEventDetailPage } from "./PublicEventDetailPage";
